/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import Highlight from '../Highlight';
import styles from './styles.scss';

const kSampleCode = (
`/*
  Parser code sample.

  The following variables are available:
  data     : hex string of the data
  hex      : array of bytes represented as string of 2 hex digits
  bin      : array of bytes represented as integers
  appeui   : application EUI
  deveui   : device EUI
  fport    : message port field
*/

var temperature =
  Number((bin[2] * 256 + bin[1]) * 0.00268 - 46.85).toFixed(2);
var humidity =
  Number(bin[3] * 0.49 - 6).toFixed(2);
return {
  T: temperature,
  H: humidity,
  length: data.length
};
`
);

class ScriptSample extends React.Component {

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className={styles.sample}>
        <pre>
          <code>
            <Highlight code={kSampleCode} />
          </code>
        </pre>
      </div>
    );
  }
}

export default ScriptSample;




// WEBPACK FOOTER //
// ./src/containers/Application/coms/ApplicationDetail/coms/ParseView/coms/ScriptSample/index.jsx